import Vue from 'vue';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required, digits, numeric, email, confirmed } from 'vee-validate/dist/rules';

export default function ({ app }) {
  const i18n = app.i18n;

  extend('limit', (value, params, ctx) => {
    const [min, max] = params;
    if ((value && value.length < min) || value.length > max) {
      return i18n.t('common.limitInput', {field: `${ctx.field}`, min: min, max: max})
    }
    return true;
  });

  extend('required', {
    ...required,
    message: () => i18n.t('common.requiredInput'),
  });

  extend('required-select', {
    ...required,
    message: (field) => i18n.t('common.requiredSelect', {field: `${field}`}),
  });

  extend('numeric', {
    ...numeric,
    message: (field) => i18n.t('common.numeric', {field: `${field}`}),
  });

  extend('digits', {
    ...digits,
    message: (field) => i18n.t('common.digits', {field: `${field}`}),
  });

  extend('email', {
    ...email,
    message: () => i18n.t('common.emailInvalid'),
  });

  extend('confirmed', {
    ...confirmed,
    message: () => i18n.t('common.passwordConfirmed'),
  });

  extend('password', {
    validate: value => {
      let regex = /^(?=.*[a-zA-Z]{1,15})(?=.*[0-9]{1,15})(?=.*[~!@#$%^&*+=-]{0,14}).{8,16}$/.test(value);
      if (!regex) {
        return i18n.t('common.passwordInvalid');
      } else {
        return true;
      }
    },
  });

  extend('koenbetween', {
    validate: (value, params) => {
      const [min, max] = params;
      const regex = /^[가-힣|a-z|A-Z|]+$/;
      if ((value && (value.length < min || value.length > max)) || !regex.test(value)) {
        return i18n.t('common.koenBetween', {min: min, max: max})
      } else {
        return true;
      }
    },
  });

  extend('ennumbetween', {
    validate: (value, params) => {
      const [min, max] = params;
      const regex = /^[0-9|a-z|A-Z-_]+$/;
      if ((value && (value.length < min || value.length > max)) || !regex.test(value)) {
        return i18n.t('common.enNumBetween', {min: min, max: max})
      } else {
        return true;
      }
    },
  });

  extend('koennumbetween', {
    validate: (value, params) => {
      const [min, max] = params;
      const regex = /^[0-9|가-힣|a-z|A-Z|]+$/;
      if ((value && (value.length < min || value.length > max)) || !regex.test(value)) {
        return i18n.t('common.koEnNumBetween', {min: min, max: max})
      } else {
        return true;
      }
    },
  });

  extend('numbetween', {
    validate: (value, params) => {
      const [min, max] = params;
      const regex = new RegExp(`^(?=.[0-9]).{${min},${max}}$`);
      if (!regex.test(value)) {
        return i18n.t('common.numBetween', {min: min, max: max})
      } else {
        return true;
      }
    },
  });

  extend('businesslicensenumber', {
    validate: (value, params) => {
      const [num] = params;
      const regex = new RegExp(`^(?=.[0-9]).{${num}}$`);
      if (!regex.test(value)) {
        return i18n.t('common.businessLicenseNumber')
      } else {
        return true;
      }
    },
  });

  extend('max', (value, params) => {
    const [max] = params;
    if (value && value.length > max) {
      return i18n.t('common.maxLength', {max: max})
    }
    return true;
  });

  extend('nickname', {
    validate: (value, params) => {
      const [min, max] = params;
      if (value && (value.length < min || value.length > max)) {
        return i18n.t('common.nicknameInvalid', {min: min, max: max})
      } else {
        return true;
      }
    },
  });

  extend('name', {
    validate: (value, params) => {
      const [min, max] = params;
      if (value && (value.length < min || value.length > max)) {
        return i18n.t('common.nameInvalid', {min: min, max: max})
      } else {
        return true;
      }
    },
  });

  extend('restricttime', {
    validate: (value, params) => {
      const [len] = params;
      const regex = new RegExp(`^([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d$`);
      if (value?.length > len || !regex.test(value)) {
        return `HH:MM:SS(24시간제) 형식으로 입력 가능합니다.`;
      } else {
        return true;
      }
    },
  });

  Vue.component('ValidationObserver', ValidationObserver);
  Vue.component('ValidationProvider', ValidationProvider);
}
